/**
 * @typedef {Object} MouseInfo
 * @property {number} clientX
 * @property {number} clientY
 * @property {number} deltaX
 * @property {number} deltaY
 * @property {number} duration 从拖拽开始到现在过了多久
 * @property {MouseEvent | TouchEvent | DragEvent} event
 */
/**
 * 在 mousedown 或者 touchstart 中调用这个方法，可以
 * 开始侦听整个页面的 mousemove 或者 touchmove，直到鼠标按键抬起
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function startMouseMove({
  initialEvent,
  onMove,
  onEnd = () => void 0,
  trigger = undefined
}) {
  var _initialEvent$target, _initialEvent$changed;
  // @ts-ignore
  const ultDocumnet = ((_initialEvent$target = initialEvent.target) === null || _initialEvent$target === void 0 ? void 0 : _initialEvent$target.ownerDocument) || document;
  const touchId = 'changedTouches' in initialEvent ? (_initialEvent$changed = initialEvent.changedTouches[0]) === null || _initialEvent$changed === void 0 ? void 0 : _initialEvent$changed.identifier : undefined;
  const sinceTime = Date.now();
  let oX = 0;
  let oY = 0;
  /**
   * @param {MouseEvent | TouchEvent} ev
   * @returns {MouseInfo | null}
   */
  function cvtEventToMouseInfo(ev) {
    let clientX;
    let clientY;
    if ('touches' in ev) {
      const touch = ev.changedTouches[0];
      if (!touch || touch.identifier !== touchId) return null;
      clientX = touch.clientX;
      clientY = touch.clientY;
    } else {
      clientX = ev.clientX;
      clientY = ev.clientY;
    }
    return {
      clientX,
      clientY,
      deltaX: clientX - oX,
      deltaY: clientY - oY,
      duration: Date.now() - sinceTime,
      event: ev
    };
  }
  const initData = cvtEventToMouseInfo(initialEvent);
  if (!initData) return Promise.reject(new Error('Invalid initial event'));
  initialEvent.preventDefault();
  oX = initData.clientX;
  oY = initData.clientY;
  return new Promise(resolve => {
    let raf = 0;
    const handleMouseMove = function (ev) {
      const data = cvtEventToMouseInfo(ev);
      if (!data) return;
      ev.stopPropagation();
      if (!raf) raf = requestAnimationFrame(() => {
        raf = 0;
        onMove === null || onMove === void 0 || onMove(data);
      });
    };
    // 补全默认的两种触发事件
    const getTrigger = () => {
      if (trigger) return trigger;
      if ('touches' in initialEvent) {
        return TouchListener;
      }
      return MouseListener;
    };
    const internalTrigger = getTrigger();
    // 补全 默认使用鼠标移动作为onMove的event
    if (!internalTrigger.find(item => item.type === 'onMove')) {
      internalTrigger.push(DefaultMouseMoveListener);
    }
    /** 达成某种条件后解绑所有事件 并触发end */
    const onEndListener = ev => {
      const data = cvtEventToMouseInfo(ev);
      // 除了触摸事件 data不会没有值
      if (!data) return;
      ev.stopPropagation();
      internalTrigger.forEach(item => {
        var _item$remove;
        (_item$remove = item.remove) === null || _item$remove === void 0 || _item$remove.call(item);
      });
      cancelAnimationFrame(raf);
      onEnd === null || onEnd === void 0 || onEnd(data);
      resolve(data);
    };
    internalTrigger.forEach(item => {
      let listener = item.type === 'onMove' ? handleMouseMove : onEndListener;
      // 可以定义eventFilter来决定是否继续触发 如果filter返回false 则不走后续逻辑
      if (item.eventFilter) {
        const originListener = listener;
        listener = ev => {
          var _item$eventFilter;
          if ((_item$eventFilter = item.eventFilter) !== null && _item$eventFilter !== void 0 && _item$eventFilter.call(item, ev)) {
            originListener(ev);
          }
        };
      }
      ultDocumnet.body.addEventListener(item.event, listener, item.options);
      item.remove = () => {
        ultDocumnet.body.removeEventListener(item.event, listener, item.options);
      };
    });
    initData.deltaX = 0;
    initData.deltaY = 0;
    onMove === null || onMove === void 0 || onMove(initData);
  });
}
const DefaultMouseMoveListener = {
  event: 'mousemove',
  type: 'onMove',
  options: true
};
const TouchListener = [{
  event: 'touchmove',
  type: 'onMove',
  options: true
}, {
  event: 'touchend',
  type: 'onEnd',
  options: true
}, {
  event: 'touchcancel',
  type: 'onEnd',
  options: true
}];
const MouseListener = [DefaultMouseMoveListener, {
  event: 'mouseup',
  type: 'onEnd',
  options: true
}, {
  event: 'mouseleave',
  type: 'onEnd',
  options: false
}];
//# sourceMappingURL=mouseMove.js.map
